import { JetView } from 'webix-jet';
import {
    devConfig, // Development configuration settings
    providersCasino, // Casino providers configuration
    gamesCasino, // Casino games configuration
    profile, // User profile information
} from 'config/config';

/**
 * Class representing the FilterProductsBanksView.
 * @extends JetView
 */
export default class FilterProductsBanksView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size
        const id_partner = this.getParam('partner', true); // Partner ID from URL parameters

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo', // Dropdown for selecting products
                            name: 'Product',
                            localId: 'product:combo',
                            label: _('Productos'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for products
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger API call if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProductsBanksSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                // Check for errors in response
                                                                vthis.parse(resp.Data); // Populate dropdown with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Dropdown for selecting banks
                            name: 'BankId',
                            localId: 'Bank:combo',
                            label: _('Banco'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for banks
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger API call if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BanksSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                // Check for errors in response
                                                                vthis.parse(resp.Data); // Populate dropdown with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [],
                            id: 'Country',
                            on: {
                                onChange: function (data, obj) {
                                    // Enable/disable button based on selection
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0) {
                                        $$('button').enable(); // Enable button if a country is selected
                                    } else {
                                        $$('button').disable(); // Disable button if no country is selected
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };

        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Rich select for activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all states
                                { id: 'A', value: _('Activado') }, // Option for activated
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with product and bank selectors
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 70 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Left section with activation status selector
                },
            ],
        };

        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Upper section for advanced filters
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add product to bank
                            value: _('Añadir Producto a Banco'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 230, // Conditional width based on screen size
                            minWidth: 220,
                            hidden: !devConfig.getPermAction('productsBanksAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-categoriesProductsAdd',
                            click: () => {
                                this.app.callEvent('addProductBank:button', [[]]); // Event to add product to bank
                            },
                        },
                        {
                            view: 'button', // Button to clear selections
                            value: _('Limpiar'), // Localized button text
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form selections
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter products
                            value: _('Consultar'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.Partner = id_partner; // Add partner ID to filter data
                                this.app.callEvent('productsBanks:filter', [filterdata]); // Event to filter products
                                console.log(filterdata); // Log filter data
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Upper section with product and bank selectors
                                    accordion_section, // Accordion section for advanced filters
                                    buttons, // Buttons for actions
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [accordion_section1], // Main content of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                // Hide elements on small screens
                $$('grav').hide();
                $$('grav2').hide();
            }
        });
        const id_partner = this.getParam('partner', true); // Partner ID from URL parameters
        const partners = profile.Partners; // List of partners

        /**
         * Filters partners based on the partner ID.
         * @param {Object} partners - The list of partners.
         * @returns {boolean} True if the partner ID matches.
         */
        function filter_partners(partners) {
            return partners.id == id_partner; // Check if partner ID matches
        }

        var partner = partners.filter(filter_partners); // Filter partners
        var listCountries = partner[0].Countries.filter(
            // Filter countries for the selected partner
            (item) => item.value != 'Todos' && item.value != 'Default',
        );
        $$('Country').define('options', listCountries); // Define options for country select
        $$('Country').refresh(); // Refresh the country select
    }
}

// FILE DOCUMENTED
